import store from '@/store.js'
import router from '@/router.js'
import * as firebase from "firebase/app";

class AuthService {
    static requireAuth(to, from, next) {
        if (store.state.currentUser == null) {
            next({
                name: 'login'
            })
        } else {
            next()
        }
    }

    static signUp(data) {
        return new Promise(async(resolve, reject) => {
            try {
                let result = await firebase
                    .auth()
                    .createUserWithEmailAndPassword(
                        data.email,
                        data.password
                    )
                resolve(result)
            } catch (error) {
                reject(error)
            }
        })
    }

    static login(data) {
        return new Promise(async(resolve, reject) => {
            try {
                let result = await firebase
                    .auth()
                    .signInWithEmailAndPassword(
                        data.email,
                        data.password
                    )
                resolve(result)
            } catch (error) {
                reject(error)
            }
        })
    }

    static logout() {
        return new Promise(async(resolve, reject) => {
            try {
                await firebase.auth().signOut()
                store.dispatch("setRecipes", [])
                router.replace({ name: "login" })
                resolve()
            } catch (error) {
                reject(error)
            }
        })
    }

    static sendVerificationEmail() {
        return new Promise(async(resolve, reject) => {
            try {
                await firebase.auth().currentUser.sendEmailVerification()
                resolve()
            } catch (error) {
                reject(error)
            }
        })
    }

    static verifyEmail(code) {
        return new Promise(async(resolve, reject) => {
            try {
                await firebase.auth().applyActionCode(code)
                resolve()
            } catch (error) {
                reject(error)
            }
        })
    }

    static sendPasswordReset(email) {
        return new Promise(async(resolve, reject) => {
            try {
                await firebase.auth().sendPasswordResetEmail(email)
                resolve()
            } catch (error) {
                reject(error)
            }
        })
    }

    static confirmPasswordReset(code, newPassword) {
        return new Promise(async(resolve, reject) => {
            try {
                await firebase.auth().confirmPasswordReset(code, newPassword)
                resolve()
            } catch (error) {
                reject(error)
            }
        })
    }
}

export default AuthService